<template>
  <div id="app">
    <!-- <Navbar /> -->

    <div class="container mt-2">
      <div class="columns is-multiline">
        <div class="column is-full">
          <TitleHero class="column is-full" />
        </div>

        <div class="column is-full">
          <ImagesCarousel />
        </div>

        <div class="column is-full">
          <DownloadInfo class="column is-full" />
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
//import Navbar from './components/Navbar.vue'
import TitleHero from './components/TitleHero.vue'
import ImagesCarousel from './components/ImagesCarousel.vue'
import DownloadInfo from './components/DownloadInfo.vue'

export default {
  name: 'App',
  components: {
    //Navbar,
    TitleHero,
    ImagesCarousel,
    DownloadInfo
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
